

import { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useLocation } from 'react-router-dom';
import { FaCircle } from "react-icons/fa";
import styles from "./SportsCard.module.css";
import SportsOddsDetails from "../sportsOddsDetails/SportsOddsDetails";
// import { ReactComponent as TennisIcon } from "../../../../assets/betpro/icons/tennis.svg";

// import { sportsPlaceBet } from "../../../../apiServices/SportsApi"; // Commented - file doesn't exist in Lords project
import { TbStopwatch } from "react-icons/tb";
import { GiSoccerBall } from "react-icons/gi";
// import { toast } from "react-toastify"; // Commented - not installed in Lords project
import { API_BASE_URL } from "../../../../config/api";

export default function SportsCard() {
  const [selectedTab, setSelectedTab] = useState("ALL");
  const [keepDisplayOn, setKeepDisplayOn] = useState(false);

  const [sportData, setSportData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const location = useLocation();
  const { sid, gmid } = useParams();
  const { game } = location.state || {};

  // map numeric sid -> human readable
  const sportMap = {
    4: "Cricket",
    1: "Football",
    2: "Tennis",
    15: "Basketball",
    18: "Volleyball",
  };
  const sportName = sportMap[String(sid)] || "Unknown";

  // Tabs: include FANCY for non-cricket per your request
  const cricketTabs = ["ALL", "TOSS", "BOOKMAKER", "FANCY", "FANCY-2", "EVEN-ODD"];
  const nonCricketTabs = ["ALL", "BOOKMAKER", "FANCY"];
  const isCricket = String(sid) === "4";
  const tabs = isCricket ? cricketTabs : nonCricketTabs;

  // Helper to get auth token
  const getAuthToken = () => {
    const activeRole = localStorage.getItem('activeRole');
    if (activeRole === 'owner') {
      return localStorage.getItem('ownerToken');
    } else if (activeRole === 'staff') {
      return localStorage.getItem('staffToken');
    }
    return localStorage.getItem('token');
  };

  useEffect(() => {
    let intervalId;

    const fetchSportData = async () => {
      setLoading(true);
      try {
        const token = getAuthToken();
        const response = await axios.post(
          `${API_BASE_URL}/user/cricket/get-match-private-data`,
          { gmid: gmid, sid: sid },
          {
            headers: {
              "Content-Type": "application/json",
              "Authorization": token ? `Bearer ${token}` : ''
            }
          }
        );
        if (response?.data?.success) {
          setSportData(response.data.data || []);
          setError(null);
        } else {
          setSportData([]);
          setError(response?.data?.error || "Failed to fetch sport data");
        }
      } catch (err) {
        setSportData([]);
        setError(err.message || "Failed to fetch sport data");
      } finally {
        setLoading(false);
      }
    };

    fetchSportData();
    intervalId = setInterval(fetchSportData, 2000);

    return () => clearInterval(intervalId);
  }, [gmid, sid]);

  // Convert final payload & call sportsPlaceBet via apiservices (same shape you used before)
  const handleBetSubmit = async (finalPayload) => {
    if (!finalPayload) return;

    // extract teams if present
    let teamOne = null;
    let teamTwo = null;
    if (finalPayload.match_title) {
      const parts = finalPayload.match_title.split(" v ");
      teamOne = parts[0]?.trim() || null;
      teamTwo = parts[1]?.trim() || null;
    }

    const stakeINR = Number(finalPayload.stake_amount || 0);
    const usdAmount = stakeINR ? +(stakeINR / 85).toFixed(2) : null;

    const updatedPayload = {
      user_id: Number(finalPayload.user_id || localStorage.getItem("user_id") || 0),
      game_type: String(finalPayload.game_type || ""),
      match_title: String(finalPayload.match_title || ""),
      team_one: teamOne,
      team_two: teamTwo,
      selection_name: String(finalPayload.selection_name || ""),
      category: String(finalPayload.category || ""),
      bet_type: String(finalPayload.bet_type || finalPayload.type || ""),
      odds: Number(finalPayload.odds || finalPayload.user_rate || 0),
      stake_amount: stakeINR,
      original_currency: String(finalPayload.original_currency || "INR"),
      original_amount: Number(finalPayload.original_amount || stakeINR),
      usd_amount: usdAmount,
      match_start_time: finalPayload.match_start_time || null,
      match_id: String(finalPayload.match_id || finalPayload.match_id || gmid || ""),
      eventid: String(finalPayload.eventid || finalPayload.etid || ""),
      fancy_name: String(finalPayload.marketname || finalPayload.fancy_name || ""),
      fixed: Number(finalPayload.fixed || 0),
    };

    try {
      // TODO: Implement bet placement API call for Lords
      console.log("Bet payload to submit:", updatedPayload);
      console.log("Bet submitted (placeholder)");
    } catch (err) {
      console.error("Bet placement failed:", err);
      console.error("Bet failed");
    }
  };

  const getSportIcon = (s) => {
    switch ((s || "").toLowerCase()) {
      case "cricket":
        return (
          "cricket"
        );
      case "football":
        return "football";
      case "tennis":
        return "tennis";
      default:
        return "unknown";
    }
  };

  return (
    <div className={styles.sportsWrapper}>


      <SportsOddsDetails
        selectedTab={selectedTab}
        sportData={sportData}
        data={game}
        event_name={game?.ename}
        sid={sid}
        isCricket={isCricket}
        loading={loading}
        onBetSubmit={handleBetSubmit}
      />
    </div>
  );
}
